import coindesk from '../../api/coindesk'

// initial state
const state = {
	rates:           [],
	currency:        'USD',
	direction:       '',
	amount:          0,
	convertedAmount: 0,
	bidAccepted:     false,
	bidResult:       null
}

// getters
const getters = {
	calculateBidResult: (state) => (rates) => {
		const oldRate  = state.rates[state.currency].rate_float;
		const newRate  = rates[state.currency].rate_float;
		const diffRate = newRate - oldRate;
		if (diffRate !== 0) {
			if (state.direction === 'up' && diffRate > 0 || state.direction === 'down' && diffRate < 0) {
				return 'win';
			}
			else {
				return 'lose';
			}
		}
	}
}

// actions
const actions = {
	getAllIndexes({commit, state, getters}) {
		coindesk.getIndexes(indexes => {
			const rates = indexes.bpi;
			if (state.rates) {
				if (state.bidAccepted) {
					commit('setBidResult', getters.calculateBidResult(rates))
				}
			}
			commit('setRates', rates)
			this.dispatch('indexes/calculateConvertedAmount', [state.currency, state.amount])
		})
	},
	calculateConvertedAmount({commit, state}, payLoad) {
		commit('setCurrencyAndAmount', payLoad)

		let rates  = Object.keys(state.rates).map((key) => {
			return state.rates[key]
		})
		const rate = rates.find(rate => rate.code === state.currency);

		commit('setConvertedAmount', {convertedAmount: (+state.amount / rate.rate_float).toFixed(4)})

		if (state.bidResult) {
			this.dispatch('user/changeBalance', state.bidResult === 'lose' ? -state.convertedAmount : state.convertedAmount)
		}
	},
	setBid({commit}, payLoad) {
		commit('setBidStatus', true)
		commit('setBid', payLoad)
	},
	newBid({commit}) {
		commit('setBidStatus', false)
		commit('setBidResult', null)
		commit('setCurrencyAndAmount', ['USD', 0])
	},
}

// mutations
const mutations = {
	setRates(state, rates) {
		state.rates = rates
	},

	setBid(state, payLoad) {
		state.currency  = payLoad[0]
		state.amount    = payLoad[1]
		state.direction = payLoad[2]
	},

	setBidStatus(state, status) {
		state.bidAccepted = status
	},

	setBidResult(state, status) {
		state.bidResult = status
	},

	setCurrencyAndAmount(state, payLoad) {
		state.currency = payLoad[0]
		state.amount   = payLoad[1]
	},

	setConvertedAmount(state, {convertedAmount}) {
		state.convertedAmount = convertedAmount
	},

}

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
}
